import { connect } from "react-redux";
import * as actions from "./borrower.withdrawal.actions";
import { fetch_borrower_depot } from "../../users/depot/actions";

const mapStateTopProps = (state) => {
  return {
    depot: state.depot,
    withdrawals: state.borrowerWithdrawal.withdrawals,
    create: state.borrowerWithdrawal.create,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createBorrowerWithdrawal: (
      borrowerId,
      accountId,
      amount,
      uniqueRef,
      depotId,
    ) => {
      dispatch(
        actions.create_borrower_withdrawal(
          borrowerId,
          accountId,
          amount,
          uniqueRef,
          depotId,
        ),
      );
    },
    createBorrowerSurplusWithdrawal: (borrowerIdList) => {
      dispatch(actions.borrower_surplus_withdrawal(borrowerIdList));
    },
    getBorrowerDepot: (accountId, depotId) => {
      dispatch(fetch_borrower_depot(accountId, depotId));
    },
    getWithdrawals: (borrowerId) => {
      dispatch(actions.fetch_borrower_withdrawals(borrowerId));
    },
    confirmWithdrawal: (borrowerId, depotId, withdrawalId) => {
      dispatch(
        actions.confirm_borrower_withdrawal(borrowerId, depotId, withdrawalId),
      );
    },
  };
};

export const borrowerWithdrawalConnector = connect(
  mapStateTopProps,
  mapDispatchToProps,
);
